import React from "react";
import image from "@assets/images/DietPlanHeader.png";
import BackImg from "@assets/images/stepsBack.jpg";
const MainHeader = ({
  heading = "",
  subheading = "",
  description = "",
  Image = image,
  WeeklyProgressTracker = false,
  adviseMe = false
}) => {
  return (
    <div
      className={`${WeeklyProgressTracker && "!pt-12"} bg-cover text-white relative rounded-[12px] p-5 mt-[29%] sm:mt-[15%] md:mt-0 lg:mt-[7%] xl:mt-[10%]`}
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <img
        src={Image}
        alt="image"
        className={`absolute ${(adviseMe || WeeklyProgressTracker) ? "top-[-14%]":"top-[-20%] md:top-[-25%]"}  left-1/2 -translate-x-1/2 h-full w-full max-w-[300px] max-h-[200px] block md:hidden`}
      />

      <div className="w-[100%] md:w-[50%] xl:w-[60%] mt-[110px] md:mt-0">
        <h1 className="text-[20px] text-white font-[600] font-[Lato] mb-2">
          {heading}
        </h1>
        <h2 className="text-[18px] font-[Lato] font-[600] mb-1">
          {subheading}
        </h2>
        <p className="text-[16px] font-[Lato]">{description}</p>
      </div>
      <img
        src={Image}
        alt="ExeciseImageDesktop"
        className={`${WeeklyProgressTracker ? "bottom-[2%]":"bottom-[1%]"} absolute right-0  max-w-[50%] xl:max-w-[40%] lg:min-h-[270px] hidden md:block`}
      />
    </div>
  );
};

export default MainHeader;
